module.exports = __webpack_public_path__ + "static/media/img10mob.41f6ca85.jpg";